var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal no-stacking",
      attrs: {
        id: "DeleteAccountUnableToDeleteModal",
        "data-test-hook": "modal-title-delete-account-unable-to-delete-modal"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm.getStoreType() === "Google"
            ? _c("div", [
                _c("div", { staticClass: "modal-header pb-0 pt-0" }, [
                  _c(
                    "h2",
                    {
                      staticClass: "modal-title",
                      attrs: {
                        "data-test-hook":
                          "modal-heading-delete-account-unable-to-delete-modal"
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "far fa-circle-exclamation colorOrange mr-1 mt-3"
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("xActionRequiredHeader")) + " "
                      )
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-icon-button btn-icon-button--gray",
                      attrs: {
                        "data-test-hook":
                          "x-close-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "row", attrs: { "align-h": "around" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col text-break",
                          attrs: {
                            "data-test-hook":
                              "modal-body1-text-delete-account-unable-to-delete-modal"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xActiveGoogleSubscription")) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary span9 btn-block",
                      attrs: {
                        type: "button",
                        "data-test-hook":
                          "done-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
                  )
                ])
              ])
            : _vm._e(),
          _vm.getStoreType() === "Apple"
            ? _c("div", [
                _c("div", { staticClass: "modal-header pb-0 pt-0" }, [
                  _c(
                    "h2",
                    {
                      staticClass: "modal-title",
                      attrs: {
                        "data-test-hook":
                          "modal-heading-delete-account-unable-to-delete-modal"
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "far fa-circle-exclamation colorOrange mr-1 mt-3"
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("xActionRequiredHeader")) + " "
                      )
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-icon-button btn-icon-button--gray",
                      attrs: {
                        "data-test-hook":
                          "x-close-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "row", attrs: { "align-h": "around" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col text-break",
                          attrs: {
                            "data-test-hook":
                              "modal-body1-text-delete-account-unable-to-delete-modal"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xActiveAppleSubscription")) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary span9 btn-block",
                      attrs: {
                        type: "button",
                        "data-test-hook":
                          "done-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xDone")) + " ")]
                  )
                ])
              ])
            : _vm._e(),
          _vm.getStoreType() === "Web"
            ? _c("div", [
                _c("div", { staticClass: "modal-header pb-0 pt-0" }, [
                  _c(
                    "h2",
                    {
                      staticClass: "modal-title",
                      attrs: {
                        "data-test-hook":
                          "modal-heading-delete-account-unable-to-delete-modal"
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "far fa-circle-exclamation colorOrange mr-1 mt-3"
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("xActiveSubscriptionHeader")) + " "
                      )
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-icon-button btn-icon-button--gray",
                      attrs: {
                        "data-test-hook":
                          "x-close-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "row", attrs: { "align-h": "around" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col text-break",
                          attrs: {
                            "data-test-hook":
                              "modal-body1-text-delete-account-unable-to-delete-modal"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xYouHaveSubscriptionText", {
                                  planName: this
                                    .deleteAccountUnableToDeleteModalInfo
                                    .planName
                                })
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "row mt-4 mb-0",
                      attrs: { "align-h": "around" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col",
                          attrs: {
                            "data-test-hook":
                              "modal-body2-text-delete-account-unable-to-delete-modal"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("xAreYouSureText")) + " ")]
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "modal-footer pr-5" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: {
                        type: "button",
                        "data-test-hook":
                          "keep-plan-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xKeepPlan")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        "data-test-hook":
                          "cancel-plan-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancelPlan()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xYesCancelPlan")) + " ")]
                  )
                ])
              ])
            : _vm._e(),
          _vm.getStoreType() === "Legacy"
            ? _c("div", [
                _c("div", { staticClass: "modal-header pb-0 pt-0" }, [
                  _c(
                    "h2",
                    {
                      staticClass: "modal-title",
                      attrs: {
                        "data-test-hook":
                          "modal-heading-delete-account-unable-to-delete-modal"
                      }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "far fa-circle-exclamation colorOrange mr-1 mt-3"
                      }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("xActiveSubscriptionHeader")) + " "
                      )
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-icon-button btn-icon-button--gray",
                      attrs: {
                        "data-test-hook":
                          "x-close-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "row", attrs: { "align-h": "around" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col",
                          attrs: {
                            "data-test-hook":
                              "modal-body1-text-delete-account-unable-to-delete-modal"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xYouHaveSubscriptionText", {
                                  planName: this
                                    .deleteAccountUnableToDeleteModalInfo
                                    .legacyPlanName
                                })
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "row mt-4 mb-0",
                      attrs: { "align-h": "around" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col",
                          attrs: {
                            "data-test-hook":
                              "modal-body2-text-delete-account-unable-to-delete-modal"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("xAreYouSureText")) + " ")]
                      )
                    ]
                  )
                ]),
                _c("div", { staticClass: "modal-footer pr-5" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: {
                        type: "button",
                        "data-test-hook":
                          "keep-plan-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xKeepPlan")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        "data-test-hook":
                          "cancel-plan-button-delete-account-unable-to-delete-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancelPlan()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xYesCancelPlan")) + " ")]
                  )
                ])
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }